import React from "react";
import colors from "../colors";
import { ReactComponent as Googleplay } from "../../icons/googleplay.svg";
import { ReactComponent as Appstore } from "../../icons/appstore.svg";

const CannotUseService = () => {
    return (
        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', width: '100vw', marginTop: 80 }}>
            <p style={{ color: colors.darkBlue, textAlign: 'center' }}>Shërbimi mund të aksesohet nga aplikacioni "Easypay" në mobile.</p>
            <div>
                <Googleplay style={{ marginRight: 20, cursor: 'pointer' }} onClick={() => window.open('https://play.google.com/store/apps/details?id=al.inovacion.easypay&hl=en&pli=1', '_blank')} />
                <Appstore style={{ cursor: 'pointer' }} onClick={() => window.open('https://apps.apple.com/dz/app/easypay-albania/id950056401', '_blank')} />
            </div>
        </div>
    )
}
export default CannotUseService;